import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-fetching-library';
import useMetadataUpdate from '@shared/hooks/useMetadataUpdate';

const Root = styled('div')({
  display: 'contents',
  position: 'absolute',
  top: 0,
  width: '100%',
  height: 3,
  zIndex: 2000,
});

const EnvTopBar = () => {
  const theme = useTheme();
  const { query: test } = useMetadataUpdate(
    useQuery,
    [
      {
        method: 'GET',
        endpoint: `/test`,
      },
      false,
    ],
  );

  if (process.env.REACT_APP_ENV === 'production') {
    return null;
  }

  return <Root
      style={{
        backgroundColor: theme.colors[process.env.REACT_APP_ENV],
      }}
    >
      {/*<IconButton*/}
      {/*  onClick={async () => {*/}
      {/*    await test()*/}
      {/*  }}*/}
      {/*  size='small'*/}
      {/*>*/}
      {/*  {'Generate New Alert'}*/}
      {/*</IconButton>*/}
    </Root>;
};

export default EnvTopBar;
